// Consumers import each class from its own leaf file, not this barrel - importing
// via this file forces every export below to load as a side effect, which forms
// a circular dependency and breaks ng test (story #54800, 2026-07-29). Keep this
// barrel for now, but do not "simplify" call sites back to `from './infrastructure'`.
export * from './base.component';
export * from './patientComponentBase.component';
export * from './billing-base.component';
export * from './insurance-base.component';
export * from './serviceBase.component';
export * from './item-structure-base.component';
export * from './control-base.component';
export * from './admission-reports-base.component';
export * from './check-password-complexity.component';
